/**
 * Exclusive sale countdown — persists end time in sessionStorage per section.
 * Default duration: 2h 9m from first view in the tab session.
 */
(function () {
  const roots = document.querySelectorAll('[data-exclusive-sale-countdown]');
  if (!roots.length) return;

  function pad2(n) {
    return String(Math.max(0, Math.floor(n))).padStart(2, '0');
  }

  function tick(root) {
    const storageKey = root.getAttribute('data-storage-key');
    const durationSec = parseInt(root.getAttribute('data-duration-seconds'), 10) || 7740;
    let end = parseInt(sessionStorage.getItem(storageKey), 10);

    if (!end || isNaN(end)) {
      end = Date.now() + durationSec * 1000;
      sessionStorage.setItem(storageKey, String(end));
    }

    const now = Date.now();
    let rem = Math.max(0, Math.floor((end - now) / 1000));

    const h = Math.floor(rem / 3600);
    rem %= 3600;
    const m = Math.floor(rem / 60);
    const s = rem % 60;

    const hEl = root.querySelector('[data-esc-hours]');
    const mEl = root.querySelector('[data-esc-minutes]');
    const sEl = root.querySelector('[data-esc-seconds]');
    if (hEl) hEl.textContent = pad2(h);
    if (mEl) mEl.textContent = pad2(m);
    if (sEl) sEl.textContent = pad2(s);
  }

  function initRoot(root) {
    tick(root);
    setInterval(function () {
      tick(root);
    }, 1000);
  }

  roots.forEach(initRoot);
})();
